import { LoadingStates } from '@pb/utils'

import { ONLINE_TAB } from '../constants'
import { ONLINE_ORDERS_LOAD_MORE_AMOUNT, STORE_ORDERS_LOAD_MORE_AMOUNT } from './constants'
import { PurchasesState } from './types'

const initialState: PurchasesState = {
  hubOrderList: [],
  isHubOrderListPopulated: false,

  onlineOrders: [],
  onlineActiveOrders: [],
  styleYourLatest: {
    userHasOrderRecommendations: false,
    articles: [],
  },
  storeOrders: [],

  totalOrdersCount: {
    online: null,
    store: null,
  },
  shouldCallRateAndReviewAPI: false,

  isOnlineOrdersPopulated: false,
  isStoreOrdersPopulated: false,
  isOnlineLoadMoreUsed: false,
  isStoreLoadMoreUsed: false,

  cancelOnlineOrderLoadingState: LoadingStates.NotLoaded,
  onlineActiveOrdersLoadingState: LoadingStates.NotLoaded,

  noMoreOnlineResults: false,
  noMoreStoreResults: false,

  onlineOrdersDetails: [],
  storeOrdersDetails: [],

  isOnlineOrdersLoading: false,
  isStoreOrdersLoading: false,

  isOnlineOrdersLoadingFailed: false,
  isStoreOrdersLoadingFailed: false,

  fetchOnlineIndex: {
    start: 0,
    end: ONLINE_ORDERS_LOAD_MORE_AMOUNT,
  },

  fetchOnlineActiveIndex: {
    start: 0,
    end: ONLINE_ORDERS_LOAD_MORE_AMOUNT,
  },

  fetchStoreIndex: {
    start: 0,
    end: STORE_ORDERS_LOAD_MORE_AMOUNT,
  },

  isTrackingRun: false,

  selectedTab: ONLINE_TAB.id,

  isOrderDetailsLoading: false,
  isOrderDetailsLoadingFailed: false,
  isStoreOrdersAdressesFailed: false,

  isAddtoBagLoading: false,
  addToBagVerificationItem: {},

  shouldShowVerification: false,

  addToBagVerificationError: {
    hasError: false,
    errorMessage: '',
  },
}

export default initialState
